<script lang="ts" setup>
import helpers from '~/helpers'
import formatter from '~/helpers/formatter'
import type { SpecialistData } from '~/types/specialists'

defineProps<{
  specialistData: SpecialistData
}>()
</script>

<template>
  <NuxtLink
    v-if="specialistData"
    class="
      block w-full rounded-2xl border border-main-green px-8 py-3 !pb-4 text-center text-base !no-underline
      [transition:all_.4s] hover:bg-main-green [&>span]:hover:!text-white
    "
    itemprop="url"
    :to="helpers.getSpecialistPath(specialistData)"
  >
    <span class="text-sm font-medium text-main-green md:leading-tight" itemprop="name">Смотреть профиль</span>
    <span class="block text-xs leading-tight text-[#99A3AF]" itemprop="startDate">
      Запись с&nbsp;{{ formatter.formatDate(specialistData.meta.nearestDate) }}
    </span>
  </NuxtLink>
</template>
